import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class ChannelManagerGlobalSettings
 *
 */
export class ChannelManagerGlobalSettings extends Model {

}

AccessorsMutatorsDecorator('id', 'code', 'name', 'status')(ChannelManagerGlobalSettings);


// WEBPACK FOOTER //
// ./src/pms-api/models/channel-manager-global-settings.model.js